import * as React from 'react';

import { ToolInvocation } from '../types';

import { ToolCallProps } from './DefaultToolCall';
import { ToolStatus } from './ToolStatus';
import * as UserActions from './UserActions';

export const SaveStudyToolCall: React.FC<ToolCallProps> = ({ toolInvocation, message }) => (
  <div className='mt-2'>
    <UserActions.CreatedStudy message={message} />
    <ToolStatus
      state={toolInvocation.state}
      doneText='Study saved to production.'
      executingText='Saving study to production...'
    />
  </div>
);
